var _path, _path2, _path3, _g, _g2, _rect, _rect2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    viewBox: "0 0 44 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6474 5.04697C42.3207 4.78605 43.1247 5.33934 43.1046 6.06325C43.0925 17.011 43.0782 27.9583 43.0617 38.9051C43.0918 39.3333 43.0248 39.805 42.6945 40.1094C42.2859 40.5342 41.5609 40.5148 41.1429 40.1127C41.707 39.9515 42.1592 39.4297 42.1639 38.8329C42.1639 27.9052 42.1639 16.9789 42.1639 6.05388C42.18 5.65513 41.9636 5.28448 41.6474 5.04697Z",
    fill: "#00AAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.4591C0 8.96611 1.09779 7.70034 2.57574 7.48921L36.5757 2.63206C38.383 2.37388 40 3.77626 40 5.60191V38C40 39.6569 38.6569 41 37 41H3C1.34315 41 0 39.6569 0 38V10.4591Z",
    fill: "#00AAF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.3261C0 8.90945 1.0417 7.70835 2.44413 7.50801L36.5757 2.63206C38.383 2.37388 40 3.77627 40 5.60191V5.6828C40 7.18854 38.8838 8.46101 37.3909 8.65722L3.21767 13.1486C1.5128 13.3726 0 12.0456 0 10.3261Z",
    fill: "#0083C0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_323_1792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0263 31.4262C28.3171 24.5999 33.7184 18.5626 40 13.5714V17.4142C34.2717 22.1708 29.3202 27.8167 25.3287 34.1428C24.0675 32.7729 22.7563 31.4454 21.6064 29.9761C19.5084 31.231 17.1391 31.9845 14.734 32.3311C9.84294 33.0907 4.81417 32.8359 0 31.6742C0 30.7668 0 29.8589 0 28.9507C4.34922 29.9028 8.86445 30.1151 13.2751 29.4986C15.5647 29.1794 17.8935 28.7109 19.9288 27.5464C19.1324 26.2333 18.4518 24.8513 17.8949 23.4167C17.6439 22.8002 17.4752 22.1447 17.4718 21.4754C17.4664 20.8199 17.6236 20.1342 18.0427 19.6198C18.5454 18.9944 19.3647 18.6999 20.1447 18.7108C20.8871 18.717 21.5801 19.1054 22.0889 19.6369C22.728 20.2733 23.0843 21.1192 23.506 21.9063C23.8968 22.6632 24.274 23.442 24.4508 24.2846C24.6064 25.0135 24.5699 25.7712 24.3448 26.4813C23.9643 27.7169 23.2123 28.8005 22.1942 29.5802C22.7712 30.2234 23.3954 30.8289 24.0263 31.4262ZM19.891 22.1104C19.3329 22.4783 19.0279 23.1441 18.9827 23.8044C18.9422 24.4051 19.0185 25.0449 19.3518 25.5573C19.6764 26.0532 20.0159 26.5395 20.3641 27.019C21.0152 26.6241 21.5812 26.0999 22.0283 25.4779C22.4754 24.8559 22.7944 24.1488 22.9662 23.3989C23.0256 23.0564 23.0964 22.6762 22.9088 22.3632C22.7691 22.107 22.4999 21.9707 22.238 21.8796C21.4768 21.5933 20.578 21.6604 19.891 22.1084V22.1104Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_323_1792)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8485 13.6777C21.4676 14.0149 22.0808 14.3642 22.6882 14.7255C22.4424 15.1904 22.169 15.64 21.8843 16.0836C21.7221 16.3278 21.5707 16.5827 21.361 16.7901C20.9698 16.5716 20.5798 16.3508 20.1913 16.1278C20.0492 16.0314 19.8462 16.107 19.7725 16.2529C19.5337 16.6728 19.2536 17.0679 18.9364 17.4324C18.3374 17.0564 17.7396 16.6786 17.1429 16.299C17.5173 15.5682 17.9592 14.8739 18.4627 14.225C18.8339 14.4552 19.1997 14.6933 19.5729 14.9208C19.611 14.9482 19.6548 14.9667 19.7009 14.9752C19.7471 14.9836 19.7946 14.9817 19.84 14.9696C19.8854 14.9575 19.9275 14.9355 19.9633 14.9052C19.9991 14.8749 20.0278 14.8371 20.0472 14.7944C20.2719 14.3935 20.5406 14.019 20.8485 13.6777Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.60712,
    y: 4.17859,
    width: 2.78571,
    height: 6.21429,
    rx: 1.39286,
    fill: "#575757",
    stroke: "white",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30.6071,
    y: 0.75,
    width: 2.78571,
    height: 6.21429,
    rx: 1.39286,
    fill: "#575757",
    stroke: "white",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_323_1792",
    x: 0,
    y: 13.5714,
    width: 40,
    height: 21.5714,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.733333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_323_1792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_323_1792",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_323_1792",
    x: 17.1429,
    y: 13.6777,
    width: 5.54535,
    height: 4.50464,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.501961 0 0 0 0 0.733333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_323_1792"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_323_1792",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.49753db8d62b5c843de20b0dd3374c74.svg";
export { ForwardRef as ReactComponent };